import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../Include/Header';
import Sidebar from '../../../Include/Sidebar';
import Footer from '../../../Include/Footer';
import Breadcrumb from '../../../../../Components/Breadcrumb/Breadcrumb';
import { Pagination, Search } from '../../../Table';
import DropDown from '../../../../../Components/DropDown';
import { getViewScrapItems } from '../../../../../Store/prosafe/proTransaction/Scrap/ViewScrapItems';

import axios from 'axios';
import toast from 'react-hot-toast';
import { V_URL } from '../../../../../BaseUrl';

const ReadOnlyInput = ({ label, value }) => (
  <div className="col-12 col-md-4 col-xl-4">
    <div className="input-block local-forms custom-select-wpr">
      <label>{label}</label>
      <input className="form-control" value={value || "-"} readOnly />
    </div>
  </div>
);

const ViewScrap = () => {

  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  const handleDownloadScrapPdf = async (id) => {
    try {
      const myurl = `${V_URL}/prosafe/download-scrap-pdf/${id}`;
      axios({
        method: "get",
        url: myurl,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
        },
      })
        .then((response) => {
          if (response.data.success === true) {
            toast.success(response?.data?.message || "PDF generated successfully");
            window.open(response?.data?.data?.pdfUrl || response?.data?.data?.url, "_blank");
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || "Something went wrong downloading PDF");
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data?._id) {
      dispatch(getViewScrapItems({ formData: { id: data?._id } }));
    }
  }, [data]);

  const itemData = useSelector((state) => state?.getViewScrapItems?.user?.data);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Scrap", link: "/main-store/user/scrap-management" },
    { label: "View Scrap", active: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = itemData?.items_details || [];
    if (search) {
      computedComments = computedComments.filter(
        (fi) =>
          fi.item_name?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }
    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, itemData]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const totals = useMemo(() => {
    return commentsData?.reduce(
      (acc, item) => {
        acc.quantity += Number(item.quantity) || 0;
        acc.amount += Number(item.amount) || 0;
        acc.total_amount += Number(item.total_amount) || 0;
        acc.gst_amount += Number(item.gst_amount) || 0;
        return acc;
      },
      {
        quantity: 0,
        amount: 0,
        total_amount: 0,
        gst_amount: 0,
      }
    );
  }, [commentsData]);

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="form-heading">
                        <h4>View Scrap Details</h4>
                      </div>
                      {data?._id && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => handleDownloadScrapPdf(data._id)}
                        >
                          <i className="fa-solid fa-file-pdf me-2"></i> Download Bill (Without GST)
                        </button>
                      )}
                    </div>

                    <div className="row">
                      <ReadOnlyInput label="Voucher No" value={data?.voucher_no} />
                      <ReadOnlyInput label="Transaction Date" value={new Date(data?.trans_date).toLocaleDateString()} />
                      <ReadOnlyInput label="Scrap By" value={data?.scrap_by?.name} />
                      <ReadOnlyInput label="Party" value={data?.party_data?.name} />
                      {/* <ReadOnlyInput
                        label="Project No"
                        value={data?.manual_pro_no}
                      /> */}
                      <ReadOnlyInput
                        label="Project"
                        value={`${data?.project_data?.name} ${data?.project_data?.project_no
                          ? `(${data?.project_data?.project_no} )`
                          : ""
                          } `}
                      />
                      <ReadOnlyInput label="Item Count" value={data?.item_count} />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="page-table-header mb-2 p-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Items List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <Search
                                  onSearch={(value) => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                  }} />
                                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                <a className="btn"><img src="/assets/img/icons/search-normal.svg"
                                  alt="search" /></a>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                        <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table border-0 custom-table comman-table mb-0">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th>Item No</th>
                          <th>Item Name</th>
                          {/* <th>Item Length</th>
                          <th>Item Width</th> */}
                          {/* <th>Item Weight</th> */}
                          {/* <th>Item Radius</th>
                          <th>Item Thickness</th>
                          <th>Assembly Weight</th>
                          <th>Surface Area</th> */}
                          <th>Scrap Qty</th>
                          <th>Rate(₹)</th>
                          <th>Amount(₹)</th>
                          <th>GST (%)</th>
                          <th>GST Amount(₹)</th>
                          <th>Total Amount(₹)</th>
                          <th>Heat No</th>
                          <th>Plate No</th>
                          <th>TC No</th>
                          <th>Remarks</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commentsData?.map((item, index) => (
                          <tr key={item._id}>
                            <td>{(currentPage - 1) * limit + index + 1}</td>
                            <td>{item.item_no || "-"}</td>
                            <td>{item.item_name || "-"}</td>
                            {/* <td>{item.item_length || "-"}</td>
                            <td>{item.item_width || "-"}</td> */}
                            {/* <td>{item.item_weight || "-"}</td> */}
                            {/* <td>{item.item_radius || "-"}</td>
                            <td>{item.item_thickness || "-"}</td>
                            <td>{item.assembly_weight || "-"}</td>
                            <td>{item.assembly_surface_area || "-"}</td> */}
                            <td>{item.quantity || "-"}</td>
                            <td>{item.rate || "-"}</td>
                            <td>{item.amount || "-"}</td>
                            <td>{item.gst || "-"}</td>
                            <td>{item.gst_amount || "-"}</td>
                            <td>{item.total_amount || "-"}</td>
                            <td>{item.heat_no || "-"}</td>
                            <td>{item.plat_no || "-"}</td>
                            <td>{item.tc_no || "-"}</td>
                            <td>{item.remarks || "-"}</td>
                            <td>{item.isAuto ? "Auto" : "Manual"}</td>
                          </tr>
                        ))}
                        {commentsData?.length > 0 && (
                          <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                            <td colSpan="3" className="text-left" style={{ padding: "0 100px" }}>Total</td>
                            <td>{totals.quantity}</td>
                            <td>-</td>
                            <td>{totals.amount.toFixed(2)}</td>
                            <td>-</td>
                            <td>{totals.gst_amount.toFixed(2)}</td>
                            <td>{totals.total_amount.toFixed(2)}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td colSpan="9"></td>
                          </tr>
                        )}
                        {commentsData?.length === 0 ? (
                          <tr>
                            <td colSpan="999">
                              <div className="no-table-data">
                                No Data Found!
                              </div>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                        aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate">
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={() => navigate("/main-store/user/scrap-management")}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <Footer />
      </div>
    </div>
  )
}

export default ViewScrap